interface RouteConfig {
  path: string
  clean?: string
}

interface RoutesConfig {
  [key: string]: RouteConfig
}

export const Routes: RoutesConfig = {
  Home: { path: "/" },
  Dashboard: { path: "/dashboard" },
  SignIn: { path: "/signin" },
  Profile: { path: "/profile" },
  Register: { path: "/Register" },
  ForgotPassword: { path: "/ForgotPassword" },
  Search: { path: "/search", clean: "/search/" },
  Favorites: { path: "/favorites", clean: "/favorites/" },
  VehicleDetails: { path: "/vehicleDetails/:id", clean: "/vehicleDetails/" },
  VehicleVisits: { path: "/vehicleVisits" },
  ResetPassword: { path: "/ResetPassword" },
  Categories: { path: "/Categories", clean: "/categories/" },
  Stages: { path: "/Stages", clean: "/stages/" },
  Settings: { path: "/settings", clean: "/settings/" },
  Customers: { path: "/customers", clean: "/customers/" },
  CustomerDetails: {
    path: "/customers/details/:id",
    clean: "/customers/details/",
  },
  Places: { path: "/places", clean: "/places" },
  PlaceDetails: { path: "/places/:placeId", clean: "/places/" },
  GeofenceDetails: { path: "/geofences/:geofenceId", clean: "/geofences/" },
  SelectOrganization: { path: "/SelectOrganization" },
  chat: { path: "/chat/:chatId", clean: "/chat/" },
  visitReport: {
    path: "/reports/visitReport/",
    clean: "/reports/visitReport/",
  },
  placesByAgentsReport: {
    path: "/reports/placesByAgents/",
    clean: "/reports/placesByAgents/",
  },
  agentVisitsReport: {
    path: "/reports/agentVisits/",
    clean: "/reports/agentVisits/",
  },
  reportDemo: {
    path: "/reports/demo/",
    clean: "/reports/demo/",
  },
  newPlacesReport: {
    path: "/reports/newPlaces/",
    clean: "/reports/newPlaces/",
  },
  salesByMonthReport: {
    path: "/reports/salesByMonth/",
    clean: "/reports/salesByMonth/",
  },
  salesBySellerReport: {
    path: "/reports/salesBySeller/",
    clean: "/reports/salesBySeller/",
  },
  Agents: { path: "/agents", clean: "/agents/" },
  AgentDetails: { path: "/agents/:id", clean: "/agents/" },
  DashboardShowcase: { path: "/dashboard/showcase" },
  ActivityLog: { path: "/activity-log", clean: "/activity-log/" },
  Analysis: { path: "/analysis", clean: "/analysis/" },
  Indicators: { path: "/indicators", clean: "/indicators/" },
  IndicatorsSellers: { path: "/indicators/sellers", clean: "/indicators/sellers/" },
  IndicatorsDispatch: { path: "/indicators/dispatch", clean: "/indicators/dispatch/" },
  IndicatorsGps: { path: "/indicators/gps", clean: "/indicators/gps/" },
  Platform: { path: "/platform", clean: "/platform/" },
  PendingRevisits: { path: "/revisitas-pendientes", clean: "/revisitas-pendientes/" },
  VehicleStops: { path: "/vehicle-stops", clean: "/vehicle-stops/" },
  Incidents: { path: "/incidents", clean: "/incidents/" },
  IncidentDetails: { path: "/incidents/:id", clean: "/incidents/" },
  WeeklyRoutes: { path: "/routes/weekly", clean: "/routes/weekly/" },
}
